import styled from 'styled-components';

import { FlexRowCenterVertical } from '@main/core-ui';

export const ToolbarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: 1em 0;
  width: 100%;
  gap: 1em;
`;

export const SectionWrapper = styled(FlexRowCenterVertical)`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;
